import { FaTriangleExclamation } from "react-icons/fa6";
import { PaymentCardShortInfo } from "@/features/payment/types";
import { twMerge } from "tailwind-merge";
import { Chip } from "@clarityos/ui/chip";
import {
  CardBrandIcon,
  CardBrandIconProps,
} from "@/features/payment/components/CardBrandIcon";

type CardStatusBadgeProps =
  | {
      type: "details";
      className?: string;
      cardInfo: PaymentCardShortInfo | null;
      iconSize?: CardBrandIconProps["size"];
    }
  | {
      type: "status";
      hasCard: boolean;
    };

export function CardChip(props: CardStatusBadgeProps) {
  if (props.type === "details") {
    if (props.cardInfo?.last4) {
      return (
        <div
          className={twMerge(
            "flex shrink-0 items-center gap-1",
            props.className,
          )}
        >
          <CardBrandIcon
            brand={props.cardInfo.brand}
            size={props.iconSize ?? "xs"}
          />
          <span className="typo-body-bold-md text-typography-label">
            {props.cardInfo.last4}
          </span>
        </div>
      );
    }

    return (
      <Chip color="negative" size="sm">
        <FaTriangleExclamation size={12} />
        No Card
      </Chip>
    );
  }

  if (props.type === "status") {
    return (
      <span
        className={twMerge(
          "rounded-12 typo-body-bold-xs inline-flex items-center gap-1 px-2.5 py-1",
          props.hasCard
            ? "bg-[#E6F9EE] text-[#00A67F]"
            : "bg-[#FFF5F2] text-[#FF2D00]",
        )}
      >
        <div
          className={twMerge(
            "size-[5px] rounded-[3px]",
            props.hasCard ? "bg-[#00A67F]" : "bg-[#FF2D00]",
          )}
        />
        {props.hasCard ? "Active" : "No Card"}
      </span>
    );
  }
}
